import {
    $axios
} from '@/assets/js/$axios'
import moment from 'moment'
import {
    GetQueryString
} from '../../assets/js/urlData.js';

import urlparam from 'urlparam';

export default {
    state: {
        confirm: {
            content: '确定提现吗？',
            decide: false,
        },
        time: "", //时间不一定准
        year: "",
        date: "",
        times: "",
        timeNext: "",
        dateTime: moment().format('YYYY-MM-DD'),
        timeUrl: '',
        month: moment().format('MM月DD日'),
        timeIndex: 0, //时间控件时刻选择
        staff: '',
        staffUrl: '',
        stores: '',
        storesUrl: '',
        headerName: 'name',
        item: '',
        itemIndex: [],
        selected: [],
        creatTime: '',
        chooseStaffStore: {},
        staffStores: {},
        chooseStaff: {},
        memberInfo: {},
        itemSelected: '',
        selectPackage: [],
        selectSpeech: '',
        chooseAppointmentItem: {},
        chooseAppointmentItemOrder: {},
        
    },
    mutations: {
        updateConfirm(state, obj) {
            state.confirm = obj
        },
        updateTime(state, time) {
            state.time = time
        },
        updateTimes(state, time) {
            state.times = time
        },
        updateTimeNext(state, time) {
            state.timeNext = time
        },
        updateTimeUrl(state, url) {
            state.timeUrl = url
        },
        updateTimeIndex(state, index) {
            state.timeIndex = index
        },
        updateDate(state, date) {
            state.date = date
        },
        updateMonth(state, date) {
            state.month = date
        },
        updateStaff(state, staff) {
            state.staff = staff
        },
        updateChooseStaff(state, staff) {
            state.chooseStaff = staff
        },
        updateStaffUrl(state, staff) {
            state.staffUrl = staff
        },
        updateStores(state, stores) {
            state.stores = stores
        },
        updateshopPid(state, stores) {
            state.shopPid = stores
        },
        updateshopInfo(state, stores) {
            state.shopInfo = stores
        },
        updateStaffStores(state, stores) {
            console.log(stores, 'stores')
            state.staffStores = stores
        },
        updatestaffInfo(state, stores) {
            state.staffInfo = stores
        },
        updateChooseStaffStore(state, stores) {

            state.chooseStaffStore = stores
        },
        updateMemberInfo(state, member) {
            state.memberInfo = member
        },

        updateStoresUrl(state, stores) {
            state.storesUrl = stores
        },
        updateheaderName(state, headerName) {
            state.headerName = headerName
        },
        updateDateTime(state, time) {
            state.dateTime = time
        },
        updateItem(state, item) {
            state.item = item
        },
        updateItemIndex(state, index) {
            state.itemIndex = index
        },
        updateSelected(state, selected) {
            state.selected = selected
        },
        updateItemSelected(state, selected) {
            state.itemSelected = selected
        },
        updateSelectSpeech(state, selected) {
            state.selectSpeech = selected
        },
        updateSelectPackage(state, selected) {
            state.selectPackage = selected
        },
        updateCreat(state, time) {
            state.creatTime = time
        },
        updateChooseAppointmentItem(state, data) {
            state.chooseAppointmentItem = data
        },
        updateChooseAppointmentItemOrder(state, data) {
            state.chooseAppointmentItemOrder = data
        },
    },
    getters: {
        getConfirm(state) {
            return state.confirm
        },
        getTimeUrl(state) {
            return state.timeUrl
        }
    },
    actions: {
        getStores(state, option) {
            let that = this;

            $axios({
                method: "POST",
                data: {
                    orgId: GetQueryString('orgId'),
                    searchKeyword: option.keyword ? option.keyword : '',
                    disableReserve: 0
                },
                url: '/org/list',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((res) => {
                let stores = res.data.data.result
                stores.forEach(element => {
                    element.closest = true
                    element.checked = false
                    element.always = true
                    element.address = element.province + element.city + element.area + element.address
                });
                that.commit('updateStores', stores)
                if (option.callback) {
                    option.callback();
                }
            })
        },
        getStaff(state, option) {

            if (!option) {
                option = {}
            }
             
            let that = this;
            let storeManage = that.state.storeManage;
            let staffIds = storeManage.chooseStore.reserveCategoryStaffResource || storeManage.chooseStoreReserveSource;
            let orderNow =  storeManage.updateOrderNow;
            $axios({
                method: "POST",
                data: {
                    currentOrgId: storeManage.chooseStore.currentOrgId,
                    dateTime: option && !option.date ? moment().format('YYYY-MM-DD') : moment(option.date.day).format('YYYY-MM-DD'),
                    staffIds: orderNow ? "" : staffIds
                },
                url: '/reserve/getReserveResourceInfo',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((res) => {

                let staffs = res.data
                console.log(res)
                that.commit('updateStaff', staffs);
                console.log(option.callback, option.callback)
                if (option.callback) {
                    option.callback()
                }
            })
        },
        getStartEnd(state) {
            // let that = this
            // console.log(that.state.tool.stores.id)
            // $axios({
            //     method: "POST",
            //     data: {
            //         currentOrgId:that.state.tool.stores.id,
            //     },
            //     url: '/reserve/getReserveConfig',
            //     headers: { "Content-Type": "application/x-www-form-urlencoded" }
            // }).then((res)=>{
            //     let startEnd = res.data
            //     let up = parseFloat(startEnd.data.upTime.replace(':','.'))
            //     let down = parseFloat(startEnd.data.downTime.replace(':','.'))
            //     let time = state.state.times
            //     time.forEach((element,index)=>{
            //         if(element.size < up || element.size >down){
            //             time.splice(index,1)
            //         }
            //     })
            //     that.commit('updateTimeSecond',time)
            //     that.commit('updateStartEnd',startEnd)
            // })
        },
        getItem(state, option) {
            //   console.log(callback, 'callback')
            let that = this;
            let storeManage = that.state.storeManage;
            let categoryIds = storeManage.chooseStoreReserveCategory;
            let orderNow =  storeManage.updateOrderNow; 
            let data = {
                memberId: option.memberId || '',
                currentOrgId: option.currentOrgId || '',
                sourceType: option.sourceType,
                categoryIds: orderNow ? "" : categoryIds
            }
            if (urlparam('canReserve')) {
                data.canReserve = true;
            }


            $axios({
                method: "POST",
                data: data,
                url: '/reserve/itemInfo',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((res) => {

                if (res.data.scode == "0") {
                    let item = res.data.data
                    item.forEach((element, index) => {
                        element.check = false
                    })

                    that.commit('updateItem', item)
                    if (option.callback) {
                        option.callback();
                    }
                } else {
                    that.$toast(res.data.msg)
                }

            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/tools/tool.js